import { OwnedBanner as SharedOwnedBanner, type OwnedRecord } from '@/components/OwnedChip'

export function OwnedBanner({ record }: { record: OwnedRecord }) {
  return (
    <SharedOwnedBanner
      owner={record.owner}
      externalUrl={record.external_url}
      lastSyncedAt={record.last_synced_at}
    />
  )
}
